import type { IconName } from "@/shared/components/icons"

export interface StyleOption {
  value: string
  label: string
  iconName: IconName
  description: string
}

export const GENERATION_STYLES: StyleOption[] = [
  { value: "realistic", label: "Realistic", iconName: "camera", description: "Photorealistic quality" },
  { value: "anime", label: "Anime", iconName: "edit", description: "Japanese animation" },
]

export interface AspectRatioOption {
  value: string
  label: string
  width: number
  height: number
}

export const ASPECT_RATIOS: AspectRatioOption[] = [
  // Landscape
  { value: "4:3", label: "4:3", width: 1152, height: 896 },
  { value: "3:2", label: "3:2", width: 1216, height: 832 },
  { value: "16:9", label: "16:9", width: 1344, height: 768 },
  { value: "2.35:1", label: "2.35:1", width: 1536, height: 640 },
  // Square & Portrait
  { value: "1:1", label: "1:1", width: 1024, height: 1024 },
  { value: "4:5", label: "4:5", width: 896, height: 1088 },
  { value: "2:3", label: "2:3", width: 832, height: 1280 },
  { value: "9:16", label: "9:16", width: 768, height: 1344 },
]

/** Default portrait/square options for new browser sessions (random pick). */
const SESSION_DEFAULT_ASPECT_RATIOS = ["1:1", "2:3"] as const

export function pickRandomSessionAspectRatio(): (typeof SESSION_DEFAULT_ASPECT_RATIOS)[number] {
  const i = Math.floor(Math.random() * SESSION_DEFAULT_ASPECT_RATIOS.length)
  return SESSION_DEFAULT_ASPECT_RATIOS[i]
}

export const IMAGE_COUNTS = [1, 2, 3, 4] as const

export const GENERATION_COST_PER_IMAGE = 10

export const GUIDANCE_SCALE = {
  min: 1,
  max: 20,
  default: 3.5,
  step: 0.1,
} as const

export const PROMPT_MAX_LENGTH = 2000
export const NEGATIVE_PROMPT_MAX_LENGTH = 500
